import { render } from "./Responsaveis.vue?vue&type=template&id=c5735664&scoped=true"
import script from "./Responsaveis.vue?vue&type=script&lang=js"
export * from "./Responsaveis.vue?vue&type=script&lang=js"

import "./Responsaveis.vue?vue&type=style&index=0&id=c5735664&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5735664"]])

export default __exports__